module.exports = {
        srcSet: __webpack_public_path__ + "0291d8b16d4213cf-300.webp"+" 300w",
        images: [{path: __webpack_public_path__ + "0291d8b16d4213cf-300.webp",width: 300,height: 214}],
        src: __webpack_public_path__ + "0291d8b16d4213cf-300.webp",
        toString: function(){return __webpack_public_path__ + "0291d8b16d4213cf-300.webp"},
        
        width: 300,
        height: 214
      }